<template>
  <div class="content text-center">
    <h1>
      Bestellstatus
    </h1>
    <div class="">
      <div class="card text-left center" style="max-width: 600px; margin: 0 auto">
        <div class="card-body">
          <div v-if="paymentSuccessful === true">
            <h4 class="text-success text-center"><span class="mdi mdi-check-circle-outline"></span> Bestellvorgang erfolgreich!</h4>
            <div class="text-center mt-3" style="margin: 16px">
              <a href="/customer" class="btn btn-primary btn-lg m-1">Zum Kundenportal</a>
            </div>
          </div>
          <div v-if="paymentSuccessful === null">
            <h4 class="text-center">Bestellvorgang nicht abgeschlossen</h4>
            <div class="text-center mt-3">
              <button @click="$router.push('/product/start')" class="btn btn-primary btn-lg m-1">Bestellvorgang starten</button>
            </div>
          </div>
          <div v-if="paymentSuccessful === false">
            <h4 class="text-error text-center">Fehler beim Bestellvorgang!</h4>
            <p>
            Bitte kontaktieren Sie uns umgehend unter
              <a href="mailto:info@nvisionic.com">info@nvisionic.com</a>
              oder unter <a href="tel:+4989413273820">089 / 413 27 38 20</a>.
             </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PaymentStatus',
  components: {},
  computed: {
    ...mapState(['paymentSuccessful'])
  }
}
</script>

<style scoped>
.heading-suffix {
  font-size: 0.7em !important;
}
</style>
